import { AdtEventAction } from '~/services/api/enums';
import { IHospitalDetails } from '~/services/api/hospital/types';
import { IDetailsSectionProps } from './DetailsSection/DetailsSection';
import { DEFAULT_EVENT_METADATA, EMPTY_VALUE, EVENT_METADATA_BY_ID } from './constants';

export const getEventMetadata = (eventId: AdtEventAction) => {
  if (!eventId) return DEFAULT_EVENT_METADATA;

  return EVENT_METADATA_BY_ID[eventId] || DEFAULT_EVENT_METADATA;
};

const mapDetailsValue = (value: any): string => {
  if (value === null || value === undefined) return EMPTY_VALUE;
  if (typeof value === 'string' && !value.trim()) return EMPTY_VALUE;

  return String(value);
};

const formatNumber = (value: number): string => {
  if (!Number.isFinite(value)) return EMPTY_VALUE;

  const normalized = Number(value.toFixed(2));

  return String(normalized);
};

export const formatHeightInFeet = (heightInFeet?: number): string => {
  if (heightInFeet === null || heightInFeet === undefined || !Number.isFinite(heightInFeet)) {
    return EMPTY_VALUE;
  }

  const safeHeight = Math.abs(heightInFeet);
  let feet = Math.trunc(safeHeight);
  let inches = Math.round((safeHeight - feet) * 12);

  if (inches === 12) {
    feet += 1;
    inches = 0;
  }

  return `${feet}'${inches}"`;
};

export const formatWeightInLbs = (weightInLbs?: number): string => {
  if (weightInLbs === null || weightInLbs === undefined || !Number.isFinite(weightInLbs)) {
    return EMPTY_VALUE;
  }

  return `${formatNumber(weightInLbs)} Lbs`;
};

export const getPatientInformationSection = (details: IHospitalDetails): IDetailsSectionProps => ({
  title: 'Patient Information',
  items: [
    {
      label: 'Phone',
      value: mapDetailsValue(details.phone),
    },
    {
      label: 'Email',
      value: mapDetailsValue(details.email),
    },
    {
      label: 'Address',
      value: mapDetailsValue(details.address),
    },
  ],
});

export const getFacilityAndProviderSection = (details: IHospitalDetails): IDetailsSectionProps => ({
  title: 'Facility & Provider',
  items: [
    {
      label: 'Program',
      value: mapDetailsValue(details.programName),
    },
    {
      label: 'Current Facility',
      value: mapDetailsValue(details.facility),
    },
    {
      label: 'Visit Class',
      value: mapDetailsValue(details.visitClass),
    },
    {
      label: 'Primary Provider',
      value: mapDetailsValue(details.primaryProvider),
    },
  ],
});

export const getMedicalInformationSection = (details: IHospitalDetails): IDetailsSectionProps => ({
  title: 'Medical Information',
  items: [
    {
      label: 'Reason For Visit',
      value: mapDetailsValue(details.reason),
    },
    {
      label: 'Diagnoses',
      value: mapDetailsValue(details.diagnoses),
    },
    {
      label: 'Height',
      value: formatHeightInFeet(details.heightInFeet),
    },
    {
      label: 'Weight',
      value: formatWeightInLbs(details.weightInLbs),
    },
  ],
});

export const getEmergencyContactAndInsuranceSection = (
  details: IHospitalDetails,
): IDetailsSectionProps => ({
  title: 'Emergency Contact & Insurance',
  items: [
    {
      label: 'Next Of Kin',
      value: mapDetailsValue(details.nextOfKin),
    },
    {
      label: 'Insurance',
      value: mapDetailsValue(details.insurance),
    },
  ],
});

export default {};
